module.exports = new __parcel__URL__("boceto3.47f30827.png").toString();